export default __webpack_public_path__ + "static/media/walletconnect.f736c106.svg";